import api from "@src/api/index";

import { useCallback, useEffect, useState } from "react";

import { useSession } from "next-auth/client";

import { VeevaStatusType } from "@src/types/index.interface"; 

const useHandleVeevaStatus = () => {
  const [session, loading] = useSession();
  const [userVeevaStatus, setUserVeevaStatus] =
    useState<VeevaStatusType | null>(null);

  const requestVeevaStatus = useCallback(async () => {
    const response = (await (
      new api.GetUserVeevaStatus(session?.user?.image?.email) as any
    ).doQuery()) as VeevaStatusType;
    setUserVeevaStatus(response);
  }, [session]);

  useEffect(() => {
    if (loading || !session) return;
    requestVeevaStatus();
  }, [session, loading, requestVeevaStatus]);

  return {
    userVeevaStatus,
  };
};

export default useHandleVeevaStatus;
